import { useTranslation } from "react-i18next";
import { useFormContext, useWatch } from "react-hook-form";
import { type WorkflowStepInput } from "~/api/types";
import { Label } from "~/atoms/label";
import { WorkflowBuilder } from "~/organisms/WorkflowBuilder";
import { type WorkflowEditorMode } from "~/pages/workflow-editor/useWorkflowEditorPage";
import { type WorkflowEditorFormValues } from "../workflowEditorForm";

interface Props {
  mode: WorkflowEditorMode;
  setSteps: React.Dispatch<React.SetStateAction<WorkflowStepInput[]>>;
}

const ignoreUnsavedChanges = () => undefined;

export function WorkflowStepsSection({ mode, setSteps }: Props) {
  const { t } = useTranslation();
  const form = useFormContext<WorkflowEditorFormValues>();

  const reviewFrom = useWatch({ control: form.control, name: "reviewFrom" });
  const reviewTo = useWatch({ control: form.control, name: "reviewTo" });

  return (
    <div className="flex flex-col gap-2">
      <div>
        <Label>{t(($) => $.commons.workflow.steps)}</Label>
        <p className="text-muted-foreground text-xs">
          {t(($) => $.commons.workflow.stepsDescription)}
        </p>
      </div>
      <WorkflowBuilder
        isEditMode={mode.type === "editing"}
        categoryId={mode.release.document.category.id}
        stepInstances={mode.release.artifact.stepInstances}
        steps={mode.steps}
        setSteps={setSteps}
        setHasUnsavedChanges={ignoreUnsavedChanges}
        reviewFrom={reviewFrom}
        reviewTo={reviewTo}
      />
    </div>
  );
}
